//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '@components/Layout';
import {
  GlobalStyle,
  ModalBaileys,
  BailetsBlock,
  MenuWrap
} from './ModalBaileys.styles';
import { CloseVideoIcon, LogoMansion } from '@assets/svgs';
import Footer from '@components/Footer';
import Menu from '@components/Menu';

type ReadProps = {
  showHChighlight?: boolean;
  isClosed?: () => void;
};

const Baileysmodal = ({ showHChighlight, isClosed }: ReadProps) => {
  return (
    <>
      <GlobalStyle />
      <Layout showHeader showMenu showNoheader>
        <ModalBaileys>
          <section>
            <BailetsBlock>
                <CloseVideoIcon animation="closeIcon" color="#000" isActive={isClosed} />
              <LogoMansion
                width={70}
                height={69}
                color="rgba(0,0,0,0.5)"
                animation="mansion"
              />
              {/* <MenuWrap>
                <Menu showBaileysMenu showBaileys mBtt="85px" />
              </MenuWrap> */}

              <h2>THE DIARY</h2>
              <span>Welcome to my world!</span>
              <p>
                I'm Bailey, the proud owner and leader of this magnificent
                mansion. But here's the twist - I'm not your typical mansion
                owner, I'm a Labrador! And guess what? My humans owners work for me!
                Together, we're on a mission to bring you the most incredible
                experiences and showcase the wonders of the world and the latest
                fashion trends. Consider this diary your exclusive pass to join
                me on this exciting journey. From dawn till dusk, I'll be
                sharing every event and collection with you, so get ready to be
                amazed! Woof!
              </p>
            </BailetsBlock>
            <BailetsBlock>
              <span style={{ textAlign: 'left', paddingBottom: '7px' }}>19 / Dec / 2022</span>
              <p style={{ marginBottom: '25px' }}>
                I was born. Without a name. I had brothers and sisters; I remmenber all of us playing together, it was so much fun.
                I was borned with a cream color. I was and I am indeep a beautiful boy. I'm very exited as well and happy and full of strengh.
                My mum is the same colr as I am, she was adorable and very beautiful more than me. My dad had a black color, he was great too.
                Sometimes I miss them and my sublings, but I have a new dad and a new mum. They are amazing with me.
              </p>

              <span style={{ textAlign: 'left', paddingBottom: '7px' }}>18 / Feb / 2023</span>
              <p>
                After eight weeks I knew my new owners. My human dad and my human mum. I was very excited because I would have a new home.
              </p>
            </BailetsBlock>
            <BailetsBlock>
              <h4>The Fashion Diary</h4>
              <span style={{ textAlign: 'left', paddingBottom: '7px' }}>19 / Dec / 2022</span>
              <p style={{ marginBottom: '25px' }}>
                I was born. Without a name. I had brothers and sisters; I remmenber all of us playing together, it was so much fun.
                I was borned with a cream color. I was and I am indeep a beautiful boy. I'm very exited as well and happy and full of strengh.
                My mum is the same colr as I am, she was adorable and very beautiful more than me. My dad had a black color, he was great too.
                Sometimes I miss them and my sublings, but I have a new dad and a new mum. They are amazing with me.
              </p>
            </BailetsBlock>
            <Footer mgT="40px" />
          </section>
        </ModalBaileys>
      </Layout>
    </>
  );
};

export default Baileysmodal;
